<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 维保任务管理
        </span>
        <div class="w_normalNav" :parent="self">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
        </div>
        <div class="searchForm1">
          <searchForm
            :items="items"
            :formPlus="form_jsgl"
            ref="searchForm_jsgl"
          >
            <template slot="last">
              <el-form-item label="任务名称" prop="taskName">
                <el-input
                  v-model="seefrom.taskName"
                  placeholder="请输入任务名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="任务人员" prop="handler">
                <el-input
                  v-model="seefrom.handler"
                  placeholder="请输入任务人员"
                ></el-input>
              </el-form-item>
              <el-form-item label="维保联系人" prop="person">
                <el-input
                  v-model="seefrom.person"
                  placeholder="请输入维保联系人"
                ></el-input>
              </el-form-item>
              <el-form-item label="任务状态" prop="status">
                <!-- <el-input
                  v-model="seefrom.status"
                  placeholder="请输入任务状态"
                ></el-input> -->
                <el-select
                  v-model="seefrom.status"
                  placeholder="请选择任务状态"
                >
                  <el-option
                    v-for="item in statusArr"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper">
          <el-table
            :data="tableData"
            style="width: 100%"
            class="stripeTable"
            max-height="500px"
            ref="Table"
          >
            <el-table-column
              show-overflow-tooltip
              :label="label"
              :prop="prop"
              :align="align"
              v-for="{ prop, label, align } in config"
              :key="prop.toString()"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="任务状态"
              prop="status"
              :formatter="statusMatter"
            ></el-table-column>
            <el-table-column label="操作" width="300">
              <template slot-scope="scope">
                <el-link
                  icon="iconfont iconwhole"
                  type="text"
                  size="small"
                  @click="seeAll(scope.$index, scope.row)"
                  >详情</el-link
                >
                <el-link
                  icon="iconfont iconwhole"
                  type="text"
                  size="small"
                  @click="receive(scope.$index, scope.row)"
                  :disabled="scope.row.status === 1 ? false : true"
                  >{{
                    scope.row.status === 1 || scope.row.status === 3 || scope.row.status === 4
                      ? "领取"
                      : "已领取"
                  }}</el-link
                >
                <!-- <el-link
                  icon="iconfont iconcheck"
                  type="text"
                  size="small"
                  @click="downloadTable(scope.$index, scope.row)"
                  >表格下载</el-link
                > -->
                <el-link
                  icon="iconfont iconxz"
                  type="text"
                  size="small"
                  @click="upload(scope.$index, scope.row)"
                  :disabled="scope.row.status === 2 ? false : true"
                  >{{ scope.row.status === 5 ? "已上报" : "上报" }}</el-link
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="footer">
            <el-pagination
              layout="prev, pager, next"
              :page-size="10"
              @current-change="handleCurrentChange"
              :total="nTotal"
            ></el-pagination>
          </div>
        </div>
        <el-dialog
          class="editDialog seeDialog"
          :visible.sync="displayForm"
          title="维保任务详情"
          :close-on-click-modal="false"
        >
          <el-form class="adddevice" ref="base" :model="base">
            <el-form-item prop="taskName" label="任务名称：">
              <p>{{ this.base.taskName }}</p>
            </el-form-item>
            <el-form-item prop="startTime" label="任务开始时间：">
              <p>{{ this.base.startTime }}</p>
            </el-form-item>
            <el-form-item prop="nowPeriod" label="任务当前周期：">
              <p>{{ this.base.nowPeriod }}</p>
            </el-form-item>
            <el-form-item prop="person" label="维保单位联系人：">
              <p>{{ this.base.person }}</p>
            </el-form-item>
            <el-form-item prop="phone" label="负责人联系电话：">
              <p>{{ this.base.phone }}</p>
            </el-form-item>
            <el-form-item prop="status" label="任务状态：">
              <p>
                {{
                  this.base.status === 1
                    ? "未领取"
                    : this.base.status === 2
                    ? "执行中"
                    : this.base.status === 3
                    ? "未启动"
                    : this.base.status === 4
                    ? "已超时"
                    : "已完成"
                }}
              </p>
            </el-form-item>
            <el-form-item prop="companyName" label="维保单位名称：">
              <p>{{ this.base.companyName }}</p>
            </el-form-item>
            <el-form-item prop="person" label="任务人员：">
              <p>{{ this.base.handler }}</p>
            </el-form-item>
            <el-form-item prop="recordResult" label="任务处理结果：">
              <p>{{ this.base.recordResult }}</p>
            </el-form-item>
            <el-form-item prop="recordImg" label="任务结果记录：">
              <p
                class="p_a"
                v-for="(item, index) in base.recordImg"
                :key="index"
                @click="seeImg(index)"
              >
                {{ item }}
              </p>
            </el-form-item>
            <el-form-item prop="recordTable" label="维保表格下载：">
              <p class="p_a" @click="downloadTable1">设施故障维修记录表.xlsx</p>
              <p class="p_a" v-if="this.wbType === 3" @click="downloadTable2">
                设施维护保养记录表.xlsx
              </p>
              <p class="p_a" v-if="this.wbType === 1" @click="downloadTable3">
                设施巡查记录表.xlsx
              </p>
              <p class="p_a" v-if="this.wbType === 2" @click="downloadTable3">
                设施检测记录表.xlsx
              </p>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 处理结果上报 -->
        <el-dialog
          class="editDialog"
          :visible.sync="uploadForm"
          title="维保任务上报"
          :close-on-click-modal="false"
        >
          <el-form
            class="adddevice"
            ref="result"
            :model="result"
            :rules="rules"
          >
            <el-form-item prop="recordResult" label="任务处理结果">
              <el-input
                type="textarea"
                v-model.trim="result.recordResult"
              ></el-input>
            </el-form-item>
            <el-form-item prop="note" label="任务处理记录">
              <!-- <el-input type="textarea" v-model.trim="result.note"></el-input> -->
              <el-upload-secondary
                class="YnormalCard"
                v-model="result.note"
                :limit="5"
                accepts="png,jpg,pdf"
              >
                <i class="el-icon-plus"></i>
              </el-upload-secondary>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button class="cancelButton" @click="uploadForm = false"
              >取 消</el-button
            >
            <el-button class="confirmButton" type="primary" @click="submitForm"
              >确 定</el-button
            >
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { dt, obj2urlsp } from "utils";

export default {
  data() {
    return {
      rules: {
        recordResult: [
          { required: true, message: "请输入维保结果", trigger: "blur" },
        ],
      },
      items: [],
      statusArr: [
        { id: 1, label: "未领取" },
        { id: 2, label: "执行中" },
        { id: 3, label: "未启动" },
        { id: 4, label: "已超时" },
        { id: 5, label: "已完成" },
      ],
      statusChina: "",
      form_jsgl: {},
      tabName: "jsgl",
      other: {},
      displayForm: false,
      uploadForm: false,
      upId: "",
      seefrom: {
        taskName: "",
        person: "",
        handler: "",
        status: "",
      },
      base: {
        taskName: "",
        startTime: "",
        nowPeriod: "",
        person: "",
        handler: "",
        status: "",
        companyName: "",
        phone: "",
        recordResult: "",
        contractId: "",
        recordImg: "",
      },
      result: {
        recordResult: "",
        note: []
      },
      valueFormat: "yyyy-MM-dd HH:mm:ss",
      tableData: [],
      nTotal: 0,
      currentPage: 1,
      wbType: 0,
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        {
          prop: "taskName",
          label: "任务名称",
        },
        // {
        //   prop: "type",
        //   label: "任务类型",
        // },
        {
          prop: "nowPeriod",
          label: "当前周期",
        },
        {
          prop: "handler",
          label: "任务人员",
        },
        {
          prop: "startTime",
          label: "开始时间",
        },
      ];
    },
    dt() {
      return dt.map(({ label }) => label);
    },
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable"),
  },
  methods: {
    //任务状态
    statusMatter(row, column) {
      if (row.status === 1) {
        return "未领取";
      } else if (row.status === 2) {
        return "执行中";
      } else if (row.status === 3) {
        return "未启动";
      } else if (row.status === 4) {
        return "已超时";
      } else if (row.status === 5) {
        return "已完成";
      }
    },
    //搜索
    subSeefrom() {
      this.getTableData();
    },
    //重置
    reset() {
      this.seefrom.taskName = "";
      this.seefrom.person = "";
      this.seefrom.status = "";
      this.seefrom.handler = "";
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData();
    },
    //查询表格数据
    getTableData() {
      this.$axios
        .get(process.env.API_HOST + "operation/wTask/findAll", {
          params: {
            pageSize: 10,
            pageNum: this.currentPage,
            taskName: this.seefrom.taskName,
            person: this.seefrom.person,
            handler: this.seefrom.handler,
            status: this.seefrom.status,
            userAccount : null
          },
        })
        .then((res) => {
          this.tableData = res.data.data.list;
          this.nTotal = res.data.data.total;
        });
    },
    //详情
    seeAll(index, row) {
      //console.log(row, "详情");
      this.displayForm = true;
      this.base = {
        taskName: row.taskName,
        startTime: row.startTime,
        nowPeriod: row.nowPeriod,
        person: row.person,
        handler: row.handler,
        status: row.status,
        companyName: row.companyName,
        phone: row.phone,
        recordResult: row.recordResult,
        contractId: row.contractId,
      };
      //console.log(this.base, "base");
      this.wbType = row.types;
      this.imgArr = row.fileUrl ? row.fileUrl.split(",") : [row.fileUrl];
      this.base.recordImg = row.fileName
        ? row.fileName.split(",")
        : [row.fileName];
    },
    //详情--查看图片
    seeImg(index) {
      const c = document.createElement("a"); // 创建a标签
      c.setAttribute("target", "_blank"); // download属性
      // c.setAttribute("download", "消防设施故障维修记录表.xlsx"); // download属性
      c.setAttribute(
        "href",
        process.env.fileUrl + '/' + this.imgArr[index]
      ); // href链接
      c.click(); // 自执行点击事件
    },
    //领取
    receive(index, row) {
      this.$axiosget("operation/wTask/updateWTaskStatus", {
        params: {
          id: row.id,
        },
      }).then((res) => {
        if (res.data.status === "10000") {
          this.$message.success("领取成功！");
          this.getTableData();
        }
      });
    },
    //下载
    downloadTable1() {
      const a = document.createElement("a"); // 创建a标签
      a.setAttribute("download", "消防设施故障维修记录表.xlsx"); // download属性
      a.setAttribute("href", "/static/消防设施故障维修记录表.xlsx"); // href链接
      a.click(); // 自执行点击事件
    },
    downloadTable2() {
      const b = document.createElement("a"); // 创建a标签
      b.setAttribute("download", "消防设施维护保养记录表.xlsx"); // download属性
      b.setAttribute("href", "/static/消防设施维护保养记录表.xlsx"); // href链接
      b.click(); // 自执行点击事件
    },
    downloadTable3() {
      // 维保类型为1，2的时候下载
      this.$axiospost(
        "operation/export/wContract?contract=".concat(this.base.contractId) +
          "&type=".concat(this.wbType) +
          "&companyId=".concat(localStorage.getItem("companyId"))
      ).then((res) => {});
    },
    //上报
    upload(index, row) {
      this.uploadForm = true;
      this.upId = row.id;
      this.result.recordResult = "";
      this.result.note = [];
      if (this.$refs["result"])
        this.$refs["result"].clearValidate();
    },
    submitForm() {
      let fileName = [];
      let fileUrl = [];
      this.result.note.forEach((element) => {
        fileName.push(element.name);
        fileUrl.push(element.response.data[0]);
      });
      //console.log(this.result.note);
      this.$refs["result"].validate((valid) => {
        if (valid) {
          this.$axiospost("operation/wTask/updateWTask", {
            id: this.upId,
            recordResult: this.result.recordResult,
            fileName: fileName.join(","),
            fileUrl: fileUrl.join(","),
          }).then((res) => {
            this.uploadForm = false;
            this.$message.success("上报成功！");
            this.getTableData();
          });
        }
      });
    },
  },
  created() {
    this.getTableData();
  },
};
</script>

<style lang="less" scoped>
.seeDialog .el-dialog__body {
  padding-bottom: 45px;
  .adddevice {
    // p {
    //   color: #4c6bc3;
    //   text-decoration: underline;
    //   font-size: 14px;
    // }
    .p_a {
      color: #4c6bc3;
      text-decoration: underline;
      font-size: 14px;
    }
  }
}
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.el-input__inner:focus {
  border: 1px solid #3587c7;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/upkeep/wbrwgl.vue